document.addEventListener('DOMContentLoaded', () => {
  // We need to check if GSAP is available
  if (typeof gsap === 'undefined') {
    console.warn('GSAP is not loaded. Premium blog animations will not run.');
    return;
  }

  // --- Scroll Reveals ---
  const articles = document.querySelectorAll('.premium-article-card');
  
  // Set initial state
  gsap.set(articles, { 
    y: 60, 
    opacity: 0,
    rotationX: 10,
    transformPerspective: 1000
  });

  articles.forEach((article) => {
    gsap.to(article, {
      scrollTrigger: {
        trigger: article,
        start: 'top 85%', // trigger when top of element hits 85% down the viewport
        end: 'bottom 20%',
        toggleActions: 'play none none reverse'
      },
      y: 0,
      opacity: 1,
      rotationX: 0,
      duration: 1.2,
      ease: 'power3.out'
    });
  });

  // --- Magnetic Cursor ---
  const cursor = document.querySelector('.premium-cursor');
  const wrapper = document.querySelector('.premium-blog-wrapper');

  if (cursor && wrapper) {
    let mouseX = -100;
    let mouseY = -100;
    let cursorX = -100;
    let cursorY = -100;
    let isHovering = false;

    // Set initial GSAP state so the center of the cursor follows the mouse, and it starts hidden
    gsap.set(cursor, { xPercent: -50, yPercent: -50, scale: 0, opacity: 0 });

    // Follow mouse with slight lerp for smoothness
    gsap.ticker.add(() => {
      cursorX += (mouseX - cursorX) * 0.15;
      cursorY += (mouseY - cursorY) * 0.15;
      gsap.set(cursor, { x: cursorX, y: cursorY });
    });

    const checkCursorHover = () => {
      if (mouseX === -100 && mouseY === -100) return;
      
      const hoveredElement = document.elementFromPoint(mouseX, mouseY);
      if (hoveredElement && hoveredElement.closest('.premium-article-card')) {
        if (!isHovering) {
          gsap.to(cursor, { scale: 1, opacity: 1, duration: 0.4, ease: 'back.out(1.7)' });
          wrapper.classList.add('cursor-active');
          isHovering = true;
        }
      } else {
        if (isHovering) {
          gsap.to(cursor, { scale: 0, opacity: 0, duration: 0.4, ease: 'power2.out' });
          wrapper.classList.remove('cursor-active');
          isHovering = false;
        }
      }
    };

    window.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      checkCursorHover();
    }, { passive: true });

    window.addEventListener('scroll', () => {
      checkCursorHover();
    }, { passive: true });
    
    // Hide cursor when leaving the window
    document.addEventListener('mouseleave', () => {
      if (isHovering) {
        gsap.to(cursor, { scale: 0, opacity: 0, duration: 0.4, ease: 'power2.out' });
        wrapper.classList.remove('cursor-active');
        isHovering = false;
      }
    });
  }
});
